export default async function () {
  return [
    {
      title: "Dashboard",
      route: {
        name: "employee-dashboard",
      },
      icon: "HomeIcon",
    },
    {
      title: "Users",
      route: {
        name: "employee-users",
      },
      children: [
        {
          title: "Create",
          route: {
            name: "employee-user-create",
          },
          icon: "UserPlusIcon",
        },
        {
          title: "View All",
          route: {
            name: "employee-users",
          },
          icon: "UsersIcon",
        },
      ],
      icon: "UsersIcon",
    },
  ];
}
